import { jwtDecode } from "jwt-decode";

const SESSION_STORAGE_KEY = "spt-session_";

class Session {
  access_token = null;

  constructor() {
    this.loadSession();
  }

  getTokenObject() {
    if (this.access_token) return jwtDecode(this.access_token);
    return null;
  }

  getUsername() {
    return this.getTokenObject().sub;
  }

  isAuthenticated() {
    return this.access_token !== null;
  }

  getAccessToken() {
    return this.access_token;
  }

  loadSession() {
    this.access_token = localStorage.getItem(
      `${SESSION_STORAGE_KEY}access_token`
    );
  }

  setSession(access_token) {
    localStorage.setItem(`${SESSION_STORAGE_KEY}access_token`, access_token);
    this.access_token = access_token;
  }

  clear() {
    localStorage.removeItem(`${SESSION_STORAGE_KEY}access_token`);
    this.access_token = null;
  }
}

const session = new Session();
export default session;
